export class MezzoDTO {
  categoriaAttrezzaturaId: number;
  categoriaAttrezzaturaIdParent: number;
  targa: string;
  sigla: string;
  codiceGenereMezzo: string;
  descrizioneGenereMezzo: string;
  tipoGenereMezzo: string;
}
